/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Impero Org API
 * The Impero Backend's API for organizations, i.e. orgname.impero.com.
 */
import { useMutation, useQuery, useSuspenseQuery } from "@tanstack/react-query";
import type {
    DataTag,
    DefinedInitialDataOptions,
    DefinedUseQueryResult,
    MutationFunction,
    QueryClient,
    QueryFunction,
    QueryKey,
    UndefinedInitialDataOptions,
    UseMutationOptions,
    UseMutationResult,
    UseQueryOptions,
    UseQueryResult,
    UseSuspenseQueryOptions,
    UseSuspenseQueryResult,
} from "@tanstack/react-query";

import axios from "axios";
import type { AxiosError, AxiosRequestConfig, AxiosResponse } from "axios";

import type {
    Authenticated,
    LoginTimeout,
    PostSetupData,
    SendPinData,
    SetupData,
    TwilioStatusData,
    TwoFactorStatusResponse,
    Unauthenticated,
    ValidatePinData,
} from "../model";

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

const withQueryKey = <T extends object, K>(
    query: T,
    queryKey: K
): T & { queryKey: K } => {
    const result = { queryKey } as T & { queryKey: K };
    for (const key of Object.keys(query)) {
        // The explicit queryKey always wins, matching the previous
        // `{ ...query, queryKey }` spread where it was set last.
        if (key === "queryKey") continue;
        Object.defineProperty(result, key, {
            enumerable: true,
            configurable: true,
            get: () => (query as Record<string, unknown>)[key],
        });
    }
    return result;
};

export const getLoginStatus = (
    options?: AxiosRequestConfig
): Promise<AxiosResponse<TwoFactorStatusResponse>> => {
    return axios.get(`/api/login-status`, options);
};

export const getGetLoginStatusQueryKey = () => {
    return [`/api/login-status`] as const;
};

export const getGetLoginStatusQueryOptions = <
    TData = Awaited<ReturnType<typeof getLoginStatus>>,
    TError = AxiosError<unknown>,
>(options?: {
    query?: Partial<
        UseQueryOptions<
            Awaited<ReturnType<typeof getLoginStatus>>,
            TError,
            TData
        >
    >;
    axios?: AxiosRequestConfig;
}) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getGetLoginStatusQueryKey();

    const queryFn: QueryFunction<
        Awaited<ReturnType<typeof getLoginStatus>>
    > = ({ signal }) => getLoginStatus({ signal, ...axiosOptions });

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof getLoginStatus>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetLoginStatusQueryResult = NonNullable<
    Awaited<ReturnType<typeof getLoginStatus>>
>;
export type GetLoginStatusQueryError = AxiosError<unknown>;

export function useGetLoginStatus<
    TData = Awaited<ReturnType<typeof getLoginStatus>>,
    TError = AxiosError<unknown>,
>(
    options: {
        query: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getLoginStatus>>,
                TError,
                TData
            >
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<typeof getLoginStatus>>,
                    TError,
                    Awaited<ReturnType<typeof getLoginStatus>>
                >,
                "initialData"
            >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetLoginStatus<
    TData = Awaited<ReturnType<typeof getLoginStatus>>,
    TError = AxiosError<unknown>,
>(
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getLoginStatus>>,
                TError,
                TData
            >
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<typeof getLoginStatus>>,
                    TError,
                    Awaited<ReturnType<typeof getLoginStatus>>
                >,
                "initialData"
            >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetLoginStatus<
    TData = Awaited<ReturnType<typeof getLoginStatus>>,
    TError = AxiosError<unknown>,
>(
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getLoginStatus>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetLoginStatus<
    TData = Awaited<ReturnType<typeof getLoginStatus>>,
    TError = AxiosError<unknown>,
>(
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getLoginStatus>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions = getGetLoginStatusQueryOptions(options);

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<
        TData,
        TError
    > & { queryKey: DataTag<QueryKey, TData, TError> };

    return withQueryKey(query, queryOptions.queryKey);
}

export const getGetLoginStatusSuspenseQueryOptions = <
    TData = Awaited<ReturnType<typeof getLoginStatus>>,
    TError = AxiosError<unknown>,
>(options?: {
    query?: Partial<
        UseSuspenseQueryOptions<
            Awaited<ReturnType<typeof getLoginStatus>>,
            TError,
            TData
        >
    >;
    axios?: AxiosRequestConfig;
}) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getGetLoginStatusQueryKey();

    const queryFn: QueryFunction<
        Awaited<ReturnType<typeof getLoginStatus>>
    > = ({ signal }) => getLoginStatus({ signal, ...axiosOptions });

    return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getLoginStatus>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetLoginStatusSuspenseQueryResult = NonNullable<
    Awaited<ReturnType<typeof getLoginStatus>>
>;
export type GetLoginStatusSuspenseQueryError = AxiosError<unknown>;

export function useGetLoginStatusSuspense<
    TData = Awaited<ReturnType<typeof getLoginStatus>>,
    TError = AxiosError<unknown>,
>(
    options: {
        query: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getLoginStatus>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetLoginStatusSuspense<
    TData = Awaited<ReturnType<typeof getLoginStatus>>,
    TError = AxiosError<unknown>,
>(
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getLoginStatus>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetLoginStatusSuspense<
    TData = Awaited<ReturnType<typeof getLoginStatus>>,
    TError = AxiosError<unknown>,
>(
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getLoginStatus>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetLoginStatusSuspense<
    TData = Awaited<ReturnType<typeof getLoginStatus>>,
    TError = AxiosError<unknown>,
>(
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getLoginStatus>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions = getGetLoginStatusSuspenseQueryOptions(options);

    const query = useSuspenseQuery(
        queryOptions,
        queryClient
    ) as UseSuspenseQueryResult<TData, TError> & {
        queryKey: DataTag<QueryKey, TData, TError>;
    };

    return withQueryKey(query, queryOptions.queryKey);
}

export const postSendPin = (
    sendPinData: SendPinData,
    options?: AxiosRequestConfig
): Promise<AxiosResponse<void>> => {
    return axios.post(`/api/send-pin`, sendPinData, options);
};

export const getPostSendPinMutationOptions = <
    TError = AxiosError<void>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof postSendPin>>,
        TError,
        { data: SendPinData },
        TContext
    >;
    axios?: AxiosRequestConfig;
}): UseMutationOptions<
    Awaited<ReturnType<typeof postSendPin>>,
    TError,
    { data: SendPinData },
    TContext
> => {
    const mutationKey = ["postSendPin"];
    const { mutation: mutationOptions, axios: axiosOptions } = options
        ? options.mutation &&
          "mutationKey" in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, axios: undefined };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof postSendPin>>,
        { data: SendPinData }
    > = (props) => {
        const { data } = props ?? {};

        return postSendPin(data, axiosOptions);
    };

    return { mutationFn, ...mutationOptions };
};

export type PostSendPinMutationResult = NonNullable<
    Awaited<ReturnType<typeof postSendPin>>
>;
export type PostSendPinMutationBody = SendPinData;
export type PostSendPinMutationError = AxiosError<void>;

export const usePostSendPin = <TError = AxiosError<void>, TContext = unknown>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<typeof postSendPin>>,
            TError,
            { data: SendPinData },
            TContext
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseMutationResult<
    Awaited<ReturnType<typeof postSendPin>>,
    TError,
    { data: SendPinData },
    TContext
> => {
    return useMutation(getPostSendPinMutationOptions(options), queryClient);
};
export const getSetup2fa = (
    options?: AxiosRequestConfig
): Promise<AxiosResponse<SetupData>> => {
    return axios.get(`/api/setup-2fa`, options);
};

export const getGetSetup2faQueryKey = () => {
    return [`/api/setup-2fa`] as const;
};

export const getGetSetup2faQueryOptions = <
    TData = Awaited<ReturnType<typeof getSetup2fa>>,
    TError = AxiosError<unknown>,
>(options?: {
    query?: Partial<
        UseQueryOptions<Awaited<ReturnType<typeof getSetup2fa>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
}) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getGetSetup2faQueryKey();

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSetup2fa>>> = ({
        signal,
    }) => getSetup2fa({ signal, ...axiosOptions });

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof getSetup2fa>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetSetup2faQueryResult = NonNullable<
    Awaited<ReturnType<typeof getSetup2fa>>
>;
export type GetSetup2faQueryError = AxiosError<unknown>;

export function useGetSetup2fa<
    TData = Awaited<ReturnType<typeof getSetup2fa>>,
    TError = AxiosError<unknown>,
>(
    options: {
        query: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getSetup2fa>>,
                TError,
                TData
            >
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<typeof getSetup2fa>>,
                    TError,
                    Awaited<ReturnType<typeof getSetup2fa>>
                >,
                "initialData"
            >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetSetup2fa<
    TData = Awaited<ReturnType<typeof getSetup2fa>>,
    TError = AxiosError<unknown>,
>(
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getSetup2fa>>,
                TError,
                TData
            >
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<typeof getSetup2fa>>,
                    TError,
                    Awaited<ReturnType<typeof getSetup2fa>>
                >,
                "initialData"
            >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetSetup2fa<
    TData = Awaited<ReturnType<typeof getSetup2fa>>,
    TError = AxiosError<unknown>,
>(
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getSetup2fa>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetSetup2fa<
    TData = Awaited<ReturnType<typeof getSetup2fa>>,
    TError = AxiosError<unknown>,
>(
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getSetup2fa>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions = getGetSetup2faQueryOptions(options);

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<
        TData,
        TError
    > & { queryKey: DataTag<QueryKey, TData, TError> };

    return withQueryKey(query, queryOptions.queryKey);
}

export const getGetSetup2faSuspenseQueryOptions = <
    TData = Awaited<ReturnType<typeof getSetup2fa>>,
    TError = AxiosError<unknown>,
>(options?: {
    query?: Partial<
        UseSuspenseQueryOptions<
            Awaited<ReturnType<typeof getSetup2fa>>,
            TError,
            TData
        >
    >;
    axios?: AxiosRequestConfig;
}) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getGetSetup2faQueryKey();

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSetup2fa>>> = ({
        signal,
    }) => getSetup2fa({ signal, ...axiosOptions });

    return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getSetup2fa>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetSetup2faSuspenseQueryResult = NonNullable<
    Awaited<ReturnType<typeof getSetup2fa>>
>;
export type GetSetup2faSuspenseQueryError = AxiosError<unknown>;

export function useGetSetup2faSuspense<
    TData = Awaited<ReturnType<typeof getSetup2fa>>,
    TError = AxiosError<unknown>,
>(
    options: {
        query: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getSetup2fa>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetSetup2faSuspense<
    TData = Awaited<ReturnType<typeof getSetup2fa>>,
    TError = AxiosError<unknown>,
>(
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getSetup2fa>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetSetup2faSuspense<
    TData = Awaited<ReturnType<typeof getSetup2fa>>,
    TError = AxiosError<unknown>,
>(
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getSetup2fa>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetSetup2faSuspense<
    TData = Awaited<ReturnType<typeof getSetup2fa>>,
    TError = AxiosError<unknown>,
>(
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getSetup2fa>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions = getGetSetup2faSuspenseQueryOptions(options);

    const query = useSuspenseQuery(
        queryOptions,
        queryClient
    ) as UseSuspenseQueryResult<TData, TError> & {
        queryKey: DataTag<QueryKey, TData, TError>;
    };

    return withQueryKey(query, queryOptions.queryKey);
}

export const postSetup2fa = (
    postSetupData: PostSetupData,
    options?: AxiosRequestConfig
): Promise<AxiosResponse<SetupData>> => {
    return axios.post(`/api/setup-2fa`, postSetupData, options);
};

export const getPostSetup2faMutationOptions = <
    TError = AxiosError<Unauthenticated | LoginTimeout>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof postSetup2fa>>,
        TError,
        { data: PostSetupData },
        TContext
    >;
    axios?: AxiosRequestConfig;
}): UseMutationOptions<
    Awaited<ReturnType<typeof postSetup2fa>>,
    TError,
    { data: PostSetupData },
    TContext
> => {
    const mutationKey = ["postSetup2fa"];
    const { mutation: mutationOptions, axios: axiosOptions } = options
        ? options.mutation &&
          "mutationKey" in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, axios: undefined };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof postSetup2fa>>,
        { data: PostSetupData }
    > = (props) => {
        const { data } = props ?? {};

        return postSetup2fa(data, axiosOptions);
    };

    return { mutationFn, ...mutationOptions };
};

export type PostSetup2faMutationResult = NonNullable<
    Awaited<ReturnType<typeof postSetup2fa>>
>;
export type PostSetup2faMutationBody = PostSetupData;
export type PostSetup2faMutationError = AxiosError<
    Unauthenticated | LoginTimeout
>;

export const usePostSetup2fa = <
    TError = AxiosError<Unauthenticated | LoginTimeout>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<typeof postSetup2fa>>,
            TError,
            { data: PostSetupData },
            TContext
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseMutationResult<
    Awaited<ReturnType<typeof postSetup2fa>>,
    TError,
    { data: PostSetupData },
    TContext
> => {
    return useMutation(getPostSetup2faMutationOptions(options), queryClient);
};
export const getSmsStatus = (
    options?: AxiosRequestConfig
): Promise<AxiosResponse<void>> => {
    return axios.get(`/api/sms-status`, options);
};

export const getGetSmsStatusQueryKey = () => {
    return [`/api/sms-status`] as const;
};

export const getGetSmsStatusQueryOptions = <
    TData = Awaited<ReturnType<typeof getSmsStatus>>,
    TError = AxiosError<unknown>,
>(options?: {
    query?: Partial<
        UseQueryOptions<Awaited<ReturnType<typeof getSmsStatus>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
}) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getGetSmsStatusQueryKey();

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSmsStatus>>> = ({
        signal,
    }) => getSmsStatus({ signal, ...axiosOptions });

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof getSmsStatus>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetSmsStatusQueryResult = NonNullable<
    Awaited<ReturnType<typeof getSmsStatus>>
>;
export type GetSmsStatusQueryError = AxiosError<unknown>;

export function useGetSmsStatus<
    TData = Awaited<ReturnType<typeof getSmsStatus>>,
    TError = AxiosError<unknown>,
>(
    options: {
        query: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getSmsStatus>>,
                TError,
                TData
            >
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<typeof getSmsStatus>>,
                    TError,
                    Awaited<ReturnType<typeof getSmsStatus>>
                >,
                "initialData"
            >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetSmsStatus<
    TData = Awaited<ReturnType<typeof getSmsStatus>>,
    TError = AxiosError<unknown>,
>(
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getSmsStatus>>,
                TError,
                TData
            >
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<typeof getSmsStatus>>,
                    TError,
                    Awaited<ReturnType<typeof getSmsStatus>>
                >,
                "initialData"
            >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetSmsStatus<
    TData = Awaited<ReturnType<typeof getSmsStatus>>,
    TError = AxiosError<unknown>,
>(
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getSmsStatus>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetSmsStatus<
    TData = Awaited<ReturnType<typeof getSmsStatus>>,
    TError = AxiosError<unknown>,
>(
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getSmsStatus>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions = getGetSmsStatusQueryOptions(options);

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<
        TData,
        TError
    > & { queryKey: DataTag<QueryKey, TData, TError> };

    return withQueryKey(query, queryOptions.queryKey);
}

export const getGetSmsStatusSuspenseQueryOptions = <
    TData = Awaited<ReturnType<typeof getSmsStatus>>,
    TError = AxiosError<unknown>,
>(options?: {
    query?: Partial<
        UseSuspenseQueryOptions<
            Awaited<ReturnType<typeof getSmsStatus>>,
            TError,
            TData
        >
    >;
    axios?: AxiosRequestConfig;
}) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getGetSmsStatusQueryKey();

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSmsStatus>>> = ({
        signal,
    }) => getSmsStatus({ signal, ...axiosOptions });

    return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getSmsStatus>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetSmsStatusSuspenseQueryResult = NonNullable<
    Awaited<ReturnType<typeof getSmsStatus>>
>;
export type GetSmsStatusSuspenseQueryError = AxiosError<unknown>;

export function useGetSmsStatusSuspense<
    TData = Awaited<ReturnType<typeof getSmsStatus>>,
    TError = AxiosError<unknown>,
>(
    options: {
        query: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getSmsStatus>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetSmsStatusSuspense<
    TData = Awaited<ReturnType<typeof getSmsStatus>>,
    TError = AxiosError<unknown>,
>(
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getSmsStatus>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetSmsStatusSuspense<
    TData = Awaited<ReturnType<typeof getSmsStatus>>,
    TError = AxiosError<unknown>,
>(
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getSmsStatus>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetSmsStatusSuspense<
    TData = Awaited<ReturnType<typeof getSmsStatus>>,
    TError = AxiosError<unknown>,
>(
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getSmsStatus>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions = getGetSmsStatusSuspenseQueryOptions(options);

    const query = useSuspenseQuery(
        queryOptions,
        queryClient
    ) as UseSuspenseQueryResult<TData, TError> & {
        queryKey: DataTag<QueryKey, TData, TError>;
    };

    return withQueryKey(query, queryOptions.queryKey);
}

export const postSmsStatusCallbackTwilio = (
    twilioStatusData: TwilioStatusData,
    options?: AxiosRequestConfig
): Promise<AxiosResponse<void>> => {
    const formUrlEncoded = new URLSearchParams();
    formUrlEncoded.append(`MessageSid`, twilioStatusData.MessageSid);
    formUrlEncoded.append(`MessageStatus`, twilioStatusData.MessageStatus);
    if (
        twilioStatusData.ErrorCode !== undefined &&
        twilioStatusData.ErrorCode !== null
    ) {
        formUrlEncoded.append(
            `ErrorCode`,
            twilioStatusData.ErrorCode.toString()
        );
    }
    if (
        twilioStatusData.ErrorMessage !== undefined &&
        twilioStatusData.ErrorMessage !== null
    ) {
        formUrlEncoded.append(`ErrorMessage`, twilioStatusData.ErrorMessage);
    }

    return axios.post(
        `/api/sms-status-callback-twilio`,
        formUrlEncoded,
        options
    );
};

export const getPostSmsStatusCallbackTwilioMutationOptions = <
    TError = AxiosError<unknown>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof postSmsStatusCallbackTwilio>>,
        TError,
        { data: TwilioStatusData },
        TContext
    >;
    axios?: AxiosRequestConfig;
}): UseMutationOptions<
    Awaited<ReturnType<typeof postSmsStatusCallbackTwilio>>,
    TError,
    { data: TwilioStatusData },
    TContext
> => {
    const mutationKey = ["postSmsStatusCallbackTwilio"];
    const { mutation: mutationOptions, axios: axiosOptions } = options
        ? options.mutation &&
          "mutationKey" in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, axios: undefined };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof postSmsStatusCallbackTwilio>>,
        { data: TwilioStatusData }
    > = (props) => {
        const { data } = props ?? {};

        return postSmsStatusCallbackTwilio(data, axiosOptions);
    };

    return { mutationFn, ...mutationOptions };
};

export type PostSmsStatusCallbackTwilioMutationResult = NonNullable<
    Awaited<ReturnType<typeof postSmsStatusCallbackTwilio>>
>;
export type PostSmsStatusCallbackTwilioMutationBody = TwilioStatusData;
export type PostSmsStatusCallbackTwilioMutationError = AxiosError<unknown>;

export const usePostSmsStatusCallbackTwilio = <
    TError = AxiosError<unknown>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<typeof postSmsStatusCallbackTwilio>>,
            TError,
            { data: TwilioStatusData },
            TContext
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseMutationResult<
    Awaited<ReturnType<typeof postSmsStatusCallbackTwilio>>,
    TError,
    { data: TwilioStatusData },
    TContext
> => {
    return useMutation(
        getPostSmsStatusCallbackTwilioMutationOptions(options),
        queryClient
    );
};
export const postValidatePin = (
    validatePinData: ValidatePinData,
    options?: AxiosRequestConfig
): Promise<AxiosResponse<Authenticated>> => {
    return axios.post(`/api/validate-pin`, validatePinData, options);
};

export const getPostValidatePinMutationOptions = <
    TError = AxiosError<Unauthenticated | LoginTimeout>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof postValidatePin>>,
        TError,
        { data: ValidatePinData },
        TContext
    >;
    axios?: AxiosRequestConfig;
}): UseMutationOptions<
    Awaited<ReturnType<typeof postValidatePin>>,
    TError,
    { data: ValidatePinData },
    TContext
> => {
    const mutationKey = ["postValidatePin"];
    const { mutation: mutationOptions, axios: axiosOptions } = options
        ? options.mutation &&
          "mutationKey" in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, axios: undefined };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof postValidatePin>>,
        { data: ValidatePinData }
    > = (props) => {
        const { data } = props ?? {};

        return postValidatePin(data, axiosOptions);
    };

    return { mutationFn, ...mutationOptions };
};

export type PostValidatePinMutationResult = NonNullable<
    Awaited<ReturnType<typeof postValidatePin>>
>;
export type PostValidatePinMutationBody = ValidatePinData;
export type PostValidatePinMutationError = AxiosError<
    Unauthenticated | LoginTimeout
>;

export const usePostValidatePin = <
    TError = AxiosError<Unauthenticated | LoginTimeout>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<typeof postValidatePin>>,
            TError,
            { data: ValidatePinData },
            TContext
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseMutationResult<
    Awaited<ReturnType<typeof postValidatePin>>,
    TError,
    { data: ValidatePinData },
    TContext
> => {
    return useMutation(getPostValidatePinMutationOptions(options), queryClient);
};
